/**
 * ItemGo Logger
 * Structured logging with environment-aware levels
 */
const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV;
class Logger {
    module;
    constructor(module) {
        this.module = module;
    }
    log(level, message, data) {
        const entry = {
            timestamp: new Date().toISOString(),
            level,
            module: this.module,
            message,
            data,
        };
        if (isDev || level === 'error' || level === 'warn') {
            const prefix = `[${entry.timestamp}] [${level.toUpperCase()}] [${this.module}]`;
            switch (level) {
                case 'debug':
                    console.debug(prefix, message, data ?? '');
                    break;
                case 'info':
                    console.info(prefix, message, data ?? '');
                    break;
                case 'warn':
                    console.warn(prefix, message, data ?? '');
                    break;
                case 'error':
                    console.error(prefix, message, data ?? '');
                    break;
            }
        }
        if (!isDev && level !== 'debug') {
            this.sendToRemote(entry);
        }
    }
    sendToRemote(entry) {
        // TODO: Send to Cloud Logging / Sentry / etc.
        void entry;
    }
    debug(message, data) {
        if (isDev)
            this.log('debug', message, data);
    }
    info(message, data) {
        this.log('info', message, data);
    }
    warn(message, data) {
        this.log('warn', message, data);
    }
    error(message, data) {
        this.log('error', message, data);
    }
}
export function createLogger(module) {
    return new Logger(module);
}
export { Logger };
//# sourceMappingURL=logger.js.map